<template>
    <jet-authentication-card register>
        <Head title="Create Your Account" />

        <template #logo>
            <jet-authentication-card-header v-if="canRegister">
                <a href="/" title="Throbo"><img src="/images/logo/throbo-logo.svg" alt="Throbo Logo" /></a>
                <template #title> Create Your Account </template>
                <template #link>
                    <Link :href="route('login')" class="hover:text-indigo-500 text-indigo-600 dark:text-slate-300 dark:hover:text-slate-100 dark:underline font-medium"> sign in to your account </Link>
                </template>
            </jet-authentication-card-header>
            <jet-authentication-card-header v-if="!canRegister">
                <a href="/" title="Throbo" class="dark:hidden"><img src="/images/app_logo_login.png" alt="Throbo Logo" /></a>
                <a href="/" title="Throbo" class="hidden dark:block"><img src="/images/app_logo_login_dark.png" alt="Throbo Logo" /></a>
                <template #title>
                    <div class="flex flex-col space-y-2">
                        <div class="text-2xl">Registration by invite only</div>
                        <Link :href="route('login')" class="hover:text-brand-500 text-brand-600 dark:text-slate-300 dark:hover:text-slate-100 text-base font-medium"> Sign in to your account instead</Link>
                    </div>
                </template>
            </jet-authentication-card-header>
        </template>

        <!--<social-login></social-login>-->

        <jet-validation-errors class="mb-4" />

        <form v-if="canRegister" @submit.prevent="submit">
            <div class="text-gray-600 dark:text-slate-300 focus-within:text-indigo-700 dark:focus-within:text-slate-100">
                <label class="block text-sm font-medium" for="name">Name</label>
                <jet-input id="name" type="text" class="block mt-1 w-full" v-model="form.name" required autofocus autocomplete="name" />
            </div>

            <div class="text-gray-600 dark:text-slate-300 focus-within:text-indigo-700 dark:focus-within:text-slate-100 mt-4">
                <label class="block text-sm font-medium" for="email">Email Address</label>
                <jet-input id="email" type="email" class="block mt-1 w-full" v-model="form.email" required />
            </div>

            <div class="text-gray-600 dark:text-slate-300 focus-within:text-indigo-700 dark:focus-within:text-slate-100 mt-4">
                <label class="block text-sm font-medium" for="password">Password</label>
                <jet-input id="password" type="password" class="block mt-1 w-full" v-model="form.password" required autocomplete="new-password" />
            </div>

            <div class="text-gray-600 dark:text-slate-300 focus-within:text-indigo-700 dark:focus-within:text-slate-100 mt-4">
                <!--<jet-label for="password_confirmation" value="Confirm Password" />-->
                <label class="block text-sm font-medium" for="password_confirmation">Confirm Password</label>
                <jet-input id="password_confirmation" type="password" class="block mt-1 w-full" v-model="form.password_confirmation" required autocomplete="new-password" />
            </div>

            <div class="text-gray-600 dark:text-slate-300 focus-within:text-indigo-700 dark:focus-within:text-slate-100 mt-4">
                <!--<jet-label for="birthDateMonth" value="Birthdate" />-->
                <label class="block text-sm font-medium" for="birthDateMonth">Birthdate</label>
                <div class="flex flex-row justify-between space-x-3">
                    <div class="w-1/3">
                        <label class="block text-sm font-medium sr-only" for="birthDateMonth">Month</label>
                        <!--<label for="birthDateMonth" class="block text-gray-700 text-xs font-medium sr-only">Month</label>-->
                        <select id="birthDateMonth" v-model="form.birthdate.month" class="block mt-1 pl-3 pr-10 py-2 w-full text-base border-gray-300 focus:border-indigo-500 rounded-md focus:outline-none focus:ring-indigo-500 sm:text-sm dark:text-slate-500">
                            <option v-for="month in months" :value="month">{{ month }}</option>
                        </select>
                    </div>
                    <div class="w-1/3">
                        <label class="block text-sm font-medium sr-only" for="birthDateDate">Day</label>
                        <!--<label for="birthDateDate" class="block text-gray-700 text-xs font-medium sr-only">Day</label>-->
                        <select id="birthDateDate" v-model="form.birthdate.date" class="block mt-1 pl-3 pr-10 py-2 w-full text-base border-gray-300 focus:border-indigo-500 rounded-md focus:outline-none focus:ring-indigo-500 sm:text-sm dark:text-slate-500">
                            <option v-for="day in days" :value="day">{{ day }}</option>
                        </select>
                    </div>
                    <div class="w-1/3">
                        <label class="block text-sm font-medium sr-only" for="birthDateYear">Year</label>
                        <!--<label for="birthDateYear" class="block text-gray-700 text-xs font-medium sr-only">Year</label>-->
                        <select id="birthDateYear" v-model="form.birthdate.year" class="block mt-1 pl-3 pr-10 py-2 w-full text-base border-gray-300 focus:border-indigo-500 rounded-md focus:outline-none focus:ring-indigo-500 sm:text-sm dark:text-slate-500">
                            <option v-for="year in years" :value="year">{{ year }}</option>
                        </select>
                    </div>
                </div>
                <transition name="fade">
                    <jet-input-error v-show="underage" message="You must be at least 18 years old" class="mt-2" />
                </transition>
            </div>

            <div class="flex items-center justify-end mt-6">
                <!--<jet-button :disabled="!formValidated" class="justify-center mb-2 w-full text-base" :processing="form.processing"> Register </jet-button>-->
                <jet-button class="justify-center mb-2 w-full text-base brand-button" :processing="form.processing"> Register </jet-button>
            </div>
        </form>

        <!--<div v-if="canRegister" class="px-2 py-3 text-center">-->
        <!--    <p class="text-red-700 text-xs leading-5 font-bold">Registration is currently disabled.</p>-->
        <!--</div>-->

        <div v-if="canRegister" class="px-2 py-3 text-center">
            <p class="text-gray-700 dark:text-slate-300 text-xs leading-5">
                By signing up, you agree to our <a :href="route('policies', { filename: 'terms-of-service' })" target="_blank" class="text-gray-900 dark:text-white dark:underline hover:underline font-medium">Terms</a> &
                <a :href="route('policies', { filename: 'privacy-policy' })" class="text-gray-900 dark:text-white dark:underline hover:underline font-medium">Privacy Policy</a>.
            </p>
        </div>
    </jet-authentication-card>
</template>

<script>
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard"
import JetAuthenticationCardHeader from "@/Jetstream/AuthenticationCardHeader"
import JetButton from "@/Jetstream/Button"
import JetInput from "@/Jetstream/Input"
import JetInputError from "@/Jetstream/InputError"
import JetCheckbox from "@/Jetstream/Checkbox"
import JetLabel from "@/Jetstream/Label"
import JetValidationErrors from "@/Jetstream/ValidationErrors"
import SocialLogin from "@/Pages/Auth/SocialLogin"

let minBirthDate = moment().subtract(18, "years").startOf("day")

export default {
    components: {
        SocialLogin,
        JetAuthenticationCard,
        JetAuthenticationCardHeader,
        JetButton,
        JetInput,
        JetCheckbox,
        JetLabel,
        JetValidationErrors,
        JetInputError,
    },

    computed: {
        months() {
            return moment.months()
        },
        days() {
            return moment(this.form.birthdate.month, "MMMM").daysInMonth()
        },
        years() {
            let years = []
            let minYear = minBirthDate.format("YYYY")
            for (let i = parseInt(minYear); i >= minYear - 100; i--) {
                years.push(i)
            }
            return years
        },
        underage() {
            let birthdate = moment().year(this.form.birthdate.year).month(this.form.birthdate.month).date(this.form.birthdate.date).startOf("day")
            if (!birthdate.isValid()) return false
            return minBirthDate.isBefore(birthdate)
        },
        formValidated() {
            if (this.underage) return false
            if (!this.form.terms) return false
            return !_.some(_.pick(this.form, ["name", "email", "password", "password_confirmation"]), _.isEmpty)
        },
    },

    data() {
        return {
            form: this.$inertia.form({
                name: "",
                email: "",
                password: "",
                password_confirmation: "",
                terms: true,
                birthdate: {
                    year: parseInt(minBirthDate.format("YYYY")),
                    date: parseInt(minBirthDate.format("DD")),
                    month: minBirthDate.format("MMMM"),
                },
            }),
            canRegister: true,
        }
    },

    methods: {
        submit() {
            this.form
                .transform((data) => ({
                    ...data,
                    birthdate: data.birthdate.year + "-" + data.birthdate.month + "-" + _.padStart(data.birthdate.date, 2, 0),
                }))
                .post(this.route("register"), {
                    onFinish: () => this.form.reset("password", "password_confirmation"),
                })
        },
    },
}
</script>
